export default {"src":"/_next/static/media/cover5.1a370c77.svg","height":560,"width":1440};